import Box from '@/common/components/Box';
import BoxWithHeader from '@/common/components/BoxWithHeader';
import GoBackButton from '@/common/components/GoBackButton';
import Skeleton from '@/common/components/Skeleton';

const UpdateGovernmentAllocationLoadingState = () => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-4 items-center">
          <GoBackButton fallback={`/government-allocations`} />

          <div className="flex items-center gap-1">
            <Skeleton width={240} />
          </div>
        </div>
      </div>

      <Box className="flex gap-6 items-start h-[calc(100vh-130px)] shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
        <div className="w-full flex flex-col gap-6 h-[calc(100vh-178px)] overflow-y-auto">
          <Skeleton width={190} height={28} />

          <div className="flex gap-6">
            <div className='flex flex-col gap-1'>
              <Skeleton width={150} />
              <Skeleton width={180} height={28} />
            </div>

            <div className='flex flex-col gap-1'>
              <Skeleton width={150} />
              <Skeleton width={180} height={28} />
            </div>
          </div>

          <div className="flex gap-x-2 w-full">
            <div className='flex flex-col gap-1 w-full max-w-[250px]'>
              <Skeleton width={120} />
              <Skeleton className='w-full bg-white-100' height={52} />
            </div>

            <div className='flex flex-col gap-1 w-full max-w-[250px]'>
              <Skeleton width={120} />
              <Skeleton className='w-full bg-white-100' height={52} />
            </div>

            <div className='flex flex-col gap-1 w-full max-w-[250px]'>
              <Skeleton width={120} />
              <Skeleton className='w-full bg-white-100' height={52} />
            </div>
          </div>

          <Skeleton className='bg-white-100 rounded-lg' width={220} height={100} />

          <div className='flex flex-col gap-1 max-w-[516px]'>
            <Skeleton width={120} />
            <Skeleton className='w-full bg-white-100' height={52} />
          </div>

          <Box>
            <Skeleton width={200} height={24} />
          </Box>
        </div>

        <BoxWithHeader
          title={<Skeleton width={100} height={24} className='mb-1' />}
          subtitle={<Skeleton width={120} />}
          className="flex flex-col gap-2 h-[calc((100vh-276px)/2)]"
        >
          <div className="flex flex-col gap-2">
            <div className='flex gap-2 items-center'>
              <Skeleton className='bg-white-100 rounded-md' width={24} height={24} />

              <Skeleton width={80} />
            </div>

            <div className='flex gap-2 items-center'>
              <Skeleton className='bg-white-100 rounded-md' width={24} height={24} />

              <Skeleton width={60} />
            </div>

            <div className='flex gap-2 items-center'>
              <Skeleton className='bg-white-100 rounded-md' width={24} height={24} />

              <Skeleton width={100} />
            </div>

            <div className='flex gap-2 items-center'>
              <Skeleton className='bg-white-100 rounded-md' width={24} height={24} />

              <Skeleton width={80} />
            </div>
          </div>
        </BoxWithHeader>

      </Box>
    </div>
  )
}

export default UpdateGovernmentAllocationLoadingState
